import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl'
import Select from 'react-select';

const messages = defineMessages({
    "true": {
        id: "common.search_filter.boolean.true",
        defaultMessage: "True",
    },
    "false": {
        id: "common.search_filter.boolean.false",
        defaultMessage: "False",
    },
})

class BooleanFilter extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            operation: props.op || "is",
            value: props.value || "",
            options: []
        }
        this.state.options = [
            {
                value: true,
                label: this.props.intl.formatMessage(messages["true"])
            },
            {
                value: false,
                label: this.props.intl.formatMessage(messages["false"])
            }

        ]
        this.onChangeSelectFilter = this.onChangeSelectFilter.bind(this);
    }

    onChangeSelectFilter(value) {
        if (value !== null) {
            this.setState({ value: value.value })
            this.props.onChangeValues("add", this.props.id, value.value, value.label, this.state.operation) //Add op
        } else {
            this.setState({ value: "" })
            this.props.onChangeValues("remove", this.props.id, "") //Delete operation
        }
    }

    render() {
        return (
            <div className="panel panel-default card">
                <Select
                    name="boolean-select"
                    value={this.props.value}
                    onChange={this.onChangeSelectFilter}
                    id={this.props.id + "-op"}
                    options={this.state.options}
                />
            </div>

        );
    }
}
export default injectIntl(BooleanFilter);


// WEBPACK FOOTER //
// ./src/common/search-filter/filters-type/types/booleanFilter.component.jsx